const allRoles = {
  admin: false,
  vendor: false,
  verification: false,
  hub_manager: false,
  onboarding: false,
  driver_manager: false,
  finance: false,
  procurement: false,
  parking: false,
  recovery_agent: false,
  senior_driver_manager: false,
  fleet_general_manager: false,
  fleet_manager: false,
  telecalling: false,
  procurement_admin: false,
  commercial: false,
  procurement_hub_manager: false,
  hub_procurement: false,
  fleet_executive: false,
  workshop_partner: false,
};

export default allRoles;
